import React, { useState, useEffect } from 'react';

// Thumbnail that darkens with an eye icon on hover and opens a full-size
// lightbox on click. Renders nothing if the image fails to load.
const ImageWithPreview = ({ src, alt = '', style, onError }) => {
    const [hover, setHover] = useState(false);
    const [open, setOpen] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => { setFailed(false); }, [src]);

    if (failed) return null;

    return (
        <>
            <div
                style={{ position: 'relative', cursor: 'pointer', overflow: 'hidden', ...style }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                title="View image"
            >
                <img
                    src={src} alt={alt} loading="lazy"
                    style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => { setFailed(true); if (onError) onError(); }}
                />
                {hover && (
                    <div style={{
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,.45)', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                    }}>
                        <i className="fas fa-eye" style={{ color: '#fff', fontSize: 14 }}></i>
                    </div>
                )}
            </div>

            {open && (
                <div
                    onClick={(e) => { e.stopPropagation(); setOpen(false); }}
                    style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,.75)', zIndex: 5000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'zoom-out',
                    }}
                >
                    <img src={src} alt={alt}
                        style={{ maxWidth: '90vw', maxHeight: '90vh', borderRadius: 8, background: '#fff' }} />
                </div>
            )}
        </>
    );
};

export default ImageWithPreview;
